/* eslint-disable jsx-a11y/anchor-is-valid */
import clsx from 'clsx'
import { FC, useState } from 'react'
import { Tab, TabList, TabPanel, Tabs } from 'react-tabs'
import { TableCheckInListWrapper } from '../component/CheckIn'
import { CheckInListMasiveTab } from '../component/CheckInListMasiveTab'

const CheckInListPage: FC = () => {

  return (
    <div className='sdx_content_tab_panel'>
      <Tabs className={'sdx_sub_react_tab_panel '}>
        <TabList className={'sdx_sub_tab_panel p-0'}>
          <Tab className={'sdx_sub_tab_panel_option'}>Listado de Check In</Tab>
          {<Tab className={'sdx_sub_tab_panel_option'}>Reimpresión Masiva</Tab>}
        </TabList>
        <TabPanel>
          <TableCheckInListWrapper />
        </TabPanel>
        {(
          <TabPanel>
            <CheckInListMasiveTab />
          </TabPanel>
        )}
      </Tabs>
    </div>
  )
}

export { CheckInListPage }
